import React, { useContext } from 'react';
import parse from 'html-react-parser';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Container } from './styles/Container.styled';
import { DWTCContext } from '../utils/context';
import { getTranslationByKey } from '../helpers/translation-helper';
import {
  ContactUsSection,
  ContactBoxes,
  ContactCardBox,
  BoxDetails,
  ContactIcon,
  Seperator,
  ContactDetails,
} from './styles/ContactUsBlock.styled';
import Sprites from './Sprites';

export default function ContactDetailsList({ data, id, dir }) {
  const { translations } = useContext(DWTCContext);

  return (
    <ContactUsSection id={id}>
      <Container>
        <ContactBoxes>
          {data.contactList.map(
            ({ content: { title, email, twitterLink, icon, phones } }, index) => (
              <ContactCardBox key={`${index}_ContactCardBox`}>
                <BoxDetails>
                  {icon && (
                    <ContactIcon>
                      <LazyLoadImage src={icon.url} width={38} height={42} alt={title} />
                    </ContactIcon>
                  )}
                  <ContactDetails>
                    <p className="title">{title}</p>
                    {phones.map((number, index1) => (
                      <p className="address" dir="ltr" key={`${index1}_phones`}>
                        {parse(number)}
                      </p>
                    ))}
                    <p className="email">
                      <a href={`mailto:${email}`} className="txt-decoration">
                        {email}
                      </a>
                    </p>
                  </ContactDetails>
                </BoxDetails>
                {/* {twitterLink ? (
                  <>
                    <Seperator>&nbsp;</Seperator>
                    <BoxDetails>
                      <ContactIcon className="twtr_icon">
                        <Sprites name='twitter-x'/>
                      </ContactIcon>
                      <ContactDetails dir={dir}>
                        <span className="title twtr-title">
                          {getTranslationByKey(translations, 'Twitter')}
                        </span>
                        <a href={twitterLink.url} className="txt-decoration">
                          {twitterLink.name}
                        </a>
                      </ContactDetails>
                    </BoxDetails>
                  </>
                ) : null} */}
              </ContactCardBox>
            ),
          )}
        </ContactBoxes>
      </Container>
    </ContactUsSection>
  );
}